import RoutesDashboardPage from './RoutesDashboardPage.js';
import LocationsPage from './LocationsPage.js';
import OperatorsPage from './OperatorsPage.js';
import RouteTemplatesPage from './RouteTemplatesPage.js';
import ScheduledRoutesPage from './ScheduledRoutesPage.js';
import OperationsBoardPage from './OperationsBoardPage.js';
import LiveMapPage from './LiveMapPage.js';
import AnalyticsDashboardPage from './AnalyticsDashboardPage.js';
import IncidentsPage from './IncidentsPage.js';

export async function registerRoutePages(app) {
    app.registerPage('group/dashboard', RoutesDashboardPage);
    app.registerPage('group/locations', LocationsPage);
    app.registerPage('group/operators', OperatorsPage);
    app.registerPage('group/routes/templates', RouteTemplatesPage);
    app.registerPage('group/routes/schedule', ScheduledRoutesPage);
    app.registerPage('group/live', OperationsBoardPage);
    app.registerPage('group/live/map', LiveMapPage);
    app.registerPage('group/analytics', AnalyticsDashboardPage);
    app.registerPage('group/incidents', IncidentsPage);

    // ── Routes platform sidebar ───────────────────────────────────────────────
    app.sidebar.addMenu('group_routes', {
        name: 'group_routes',
        groupKind: 'any',
        className: 'sidebar sidebar-dark',
        items: [
            {
                icon: 'bi-speedometer2',
                text: 'Dashboard',
                route: '?page=group/dashboard',
                permissions: ['routes', 'view_routes', 'manage_routes', 'manage_group', 'manage_groups'],
            },
            {
                icon: 'bi-broadcast',
                text: 'Live View',
                route: '?page=group/live',
                permissions: ['routes', 'view_routes', 'manage_routes', 'manage_group', 'manage_groups'],
            },
            {
                icon: 'bi-calendar2-week-fill',
                text: 'Scheduled Routes',
                route: '?page=group/routes/schedule',
                permissions: ['routes', 'view_routes', 'manage_routes', 'manage_group', 'manage_groups'],
            },
            {
                icon: 'bi-signpost-split-fill',
                text: 'Planning',
                id: 'nav-planning',
                permissions: ['routes', 'view_routes', 'manage_routes', 'manage_group', 'manage_groups'],
                children: [
                    {
                        icon: 'bi-signpost-split-fill',
                        text: 'Route Templates',
                        route: '?page=group/routes/templates',
                        permissions: ['routes', 'view_routes', 'manage_routes', 'manage_group', 'manage_groups'],
                    },
                    {
                        icon: 'bi-geo-alt-fill',
                        text: 'Locations',
                        route: '?page=group/locations',
                        permissions: ['routes', 'view_routes', 'manage_routes', 'manage_cam_devices', 'manage_group', 'manage_groups'],
                    },
                    {
                        icon: 'bi-person-badge-fill',
                        text: 'Operators',
                        route: '?page=group/operators',
                        permissions: ['routes', 'manage_routes', 'manage_group', 'manage_groups'],
                    },
                ],
            },
            {
                icon: 'bi-graph-up',
                text: 'Reports',
                id: 'nav-reports-routes',
                permissions: ['view_metrics', 'manage_routes', 'manage_group', 'manage_groups'],
                children: [
                    {
                        icon: 'bi-graph-up',
                        text: 'Analytics',
                        route: '?page=group/analytics',
                        permissions: ['routes', 'view_routes', 'manage_routes', 'manage_group', 'manage_groups'],
                    },
                    {
                        icon: 'bi-exclamation-triangle-fill',
                        text: 'Incidents',
                        route: '?page=group/incidents',
                        permissions: ['manage_routes', 'manage_group', 'manage_groups'],
                    },
                ],
            },
        ],
        footer: `
        <div class="text-center py-3">
        <img style='width:150px;' src='/imgs/camactive_logo_light.png' alt='Camactive Logo' class='footer-logo'>
        <div class="text-center">${app.version}</div>
        </div>
        `
    });
}
